/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const PageAutoReportIdStyled = styled.div`
    position: relative;

    display: grid;
    grid-template-columns: 285px 1fr;
    height: 100%;

    .subscriber__content {
        padding: 32px;
        border-top: 1px solid ${colors.borderColorDisabled};
    }
`;
